import { css } from '@emotion/react';
import { hexToRgba } from '../helpers';
import { theme } from '../theme';
import { tokens } from '../tokens';
import { notificationExit } from './keyframes';
var notificationStaticStyle = css({
    borderStyle: 'solid',
    borderWidth: tokens.borderWidth.thin,
    opacity: 1,
    width: '100%',
});
export function notificationStyle(_a) {
    var isBannerMode = _a.isBannerMode, isVisible = _a.isVisible, variant = _a.variant;
    var isWarningVariant = variant === 'warning';
    var fillBackgroundColor = theme.background.main;
    return [
        notificationStaticStyle,
        css({
            // A little trick to mix multiple colors with different opacity
            background: "linear-gradient(".concat(theme[variant].transparent, ", ").concat(theme[variant].transparent, "), linear-gradient(").concat(fillBackgroundColor, ", ").concat(fillBackgroundColor, ")"),
            borderColor: hexToRgba(isWarningVariant ? theme[variant].lighter : theme[variant].main, tokens.opacity.high),
        }),
        isBannerMode &&
            css({
                borderRadius: 0,
                borderWidth: "0 0 ".concat(tokens.borderWidth.thin),
                flexGrow: 0,
                justifyContent: 'center',
            }),
        !isVisible &&
            css({
                animation: "".concat(notificationExit, " 300ms ease-out forwards"),
            }),
    ];
}
var contentStaticStyle = css({
    display: 'flex',
    flexGrow: 1,
});
export function contentStyle(_a) {
    var isBannerMode = _a.isBannerMode, isUpgrade = _a.isUpgrade, layout = _a.layout;
    return [
        contentStaticStyle,
        css({
            flexDirection: layout === 'horizontal' ? 'row' : 'column',
        }),
        isBannerMode &&
            css({
                maxWidth: '1200px',
            }),
        !isUpgrade &&
            css({
                alignItems: 'baseline',
            }),
    ];
}
function calculateLeftMargin(_a) {
    var isUpgrade = _a.isUpgrade, layout = _a.layout;
    if (layout === 'horizontal') {
        return tokens.spacing.small;
    }
    if (isUpgrade) {
        return 0;
    }
    return "-".concat(tokens.spacing.small);
}
function calculateTopMargin(_a) {
    var isUpgrade = _a.isUpgrade, layout = _a.layout;
    if (layout === 'horizontal') {
        return 0;
    }
    if (isUpgrade) {
        return tokens.spacing.small;
    }
    return tokens.spacing.xsmall;
}
export function actionStyle(_a) {
    var isUpgrade = _a.isUpgrade, layout = _a.layout;
    return css({
        flexShrink: 0,
        marginLeft: calculateLeftMargin({ isUpgrade: isUpgrade, layout: layout }),
        marginTop: calculateTopMargin({ isUpgrade: isUpgrade, layout: layout }),
    });
}
export function textContentStyle(_a) {
    var layout = _a.layout;
    return [
        layout === 'horizontal' &&
            css({
                display: 'flex',
                flexWrap: 'wrap',
            }),
        css({
            flexGrow: 1,
        }),
    ];
}
export var titleStaticStyle = css({
    lineHeight: tokens.lineHeights.relaxed,
    margin: 0,
    marginRight: tokens.spacing.small,
    padding: "".concat(tokens.spacing.xsmall, " 0"),
});
export var descriptionStaticStyle = css({
    margin: 0,
    padding: "".concat(tokens.spacing.xsmall, " 0"),
});
